import { contact } from '../Data';
import ContactForm from './Forms/ContactForm';

function Contact() {
  return (
    <div className="card-inner active" id="contacts-card">
      <div className="row card-container">
        {/* Card Wrap */}
        <div className="card-wrap col col-m-12 col-t-12 col-d-8 col-d-lg-6">
          {/* <!-- Map --> */}
          {/* <div className="card-image col col-m-12 col-t-12 col-d-4 col-d-lg-6">
            <div className="map" id="map"></div>
          </div> */}

          {/* Inner Top */}
          <div className="content inner-top">
            <div className="row">
              <div className="col col-m-12 col-t-12 col-d-12 col-d-lg-12">
                <div className="title-bg">Contacts</div>
              </div>
            </div>
          </div>

          {/* Contacts Info */}
          <div className="content contacts-info">
            <div className="row">
              <div className="col col-m-12 col-t-12 col-d-12 col-d-lg-12">
                {/* <!-- title --> */}
                <div className="title">
                  <span>Get</span> in Touch
                </div>
              </div>
            </div>

            {/* <!-- contacts items --> */}
            <div className="row contacts-items">
              {/* <!-- contacts item --> */}
              {contact.map((item, id) => {
                const { title, icon, content, link, target } = item;
                return (
                  <div
                    key={id}
                    className="col col-m-12 col-t-6 col-d-6 col-d-lg-6"
                  >
                    <a href={link ? `${link}` : null} target={target}>
                      <div className="contacts-item card-box">
                        <div className="icon">
                          <i className={`la ${icon}`}></i>
                        </div>
                        <div className="name">{title}</div>
                        <p>{content}</p>
                      </div>
                    </a>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Contacts Form */}
          {/* <ContactForm /> */}
        </div>
      </div>
    </div>
  );
}

export default Contact;
